<template>
    <form-modal
        :open="isAddModalOpen"
        :heading="$t('modals.user.add')"
        entity="user"
        mode="add"
        :submit-label="$t('modals.user.saveNew')"
        :fields="fields"
        :values="values"
        save-url="/add-user.php"
        :build-payload="buildPayload"
        @update:open="$emit('update:isAddModalOpen', $event)"
        @opened="startWithMyLanguage"
        @saved="$emit('user-saved')"
    />
</template>

<script>
import { ref, computed } from 'vue';
import FormModal from '@/components/common/FormModal.vue';
import { t, currentLocale, LOCALES } from '@/i18n';

export default {
    components: {
        FormModal,
    },
    props: {
        isAddModalOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:isAddModalOpen', 'user-saved'],
    setup() {
        const fields = computed(() => [
            { key: 'name', label: t('fields.name'), type: 'text', required: true },
            { key: 'username', label: t('fields.username'), type: 'text', required: true },
            { key: 'email', label: t('fields.email'), type: 'email', required: true },
            { key: 'locale', label: t('fields.language'), type: 'select', required: true, options: LOCALES.map((option) => ({ value: option.code, label: option.name })) },
            { key: 'password', label: t('fields.password'), type: 'password', required: true },
        ]);

        // The new user's language starts as the one the admin is using; the form is not switched to it
        const values = ref({});
        const startWithMyLanguage = () => {
            values.value = { locale: currentLocale() };
        };

        // `internal` tells the API the user is created from inside the system
        const buildPayload = (form) => ({
            name: form.name,
            username: form.username,
            email: form.email,
            locale: form.locale,
            password: form.password,
            internal: true,
        });

        return { fields, values, startWithMyLanguage, buildPayload };
    },
};
</script>
